// EmailJS Configuration
// Get your public key from: https://dashboard.emailjs.com/admin/account

export const EMAILJS_CONFIG = {
  serviceId: 'service_lebp5iw',
  templateId: 'template_u9pnoan',
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 's93Bi3MqvCK-I2hAo',
};
